import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/legal/privacy")({ component: Privacy });
function Privacy() {
  return (
    <article className="mx-auto max-w-3xl px-6 py-32 text-[color:var(--color-text)]">
      <h1 className="mb-6 text-4xl font-medium">Jotty privacy policy</h1>
      <p className="mb-10">
        Jotty is a meeting-notes service by Kugie. This page explains the data
        used by Jotty’s desktop app and cloud service.
      </p>
      <section className="mb-8">
        <h2 className="mb-3 text-2xl">Account and workspace data</h2>
        <p>
          Jotty stores the information needed to operate your account and
          workspaces, including your email, password hash, membership and
          account sessions. Workspace access determines which shared meeting
          notes you can view. Private desktop notes are available to their
          owner.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="mb-3 text-2xl">Meeting capture and AI notes</h2>
        <p>
          When you choose to capture a meeting, Jotty uses microphone and
          meeting audio through Recall.ai’s Desktop SDK. A meeting bot does not
          join the call. Captured audio is processed to produce a transcript.
          Your transcript and optional rough notes are sent through OpenRouter
          to a model provider to create enhanced notes. Jotty requests provider
          routing that disallows data collection for model training. You should
          record only conversations you are allowed to record.
        </p>
        <p className="mt-3">
          Original notes, transcripts and enhanced notes are stored separately.
          AI notes may contain mistakes; review decisions, owners and dates
          before relying on or sharing them.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="mb-3 text-2xl">Optional Google connection</h2>
        <p>
          Google is an optional calendar connection after you sign in to Jotty.
          Calendar read access supplies upcoming meeting information. The Google
          Drive file scope supports files created or selected for the Google
          Docs exporter. This connection does not provide access to your Gmail
          mailbox. Disconnecting Google stops future use of that connection; it
          does not automatically delete notes you already created.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="mb-3 text-2xl">Local copies and cloud storage</h2>
        <p>
          The desktop app stores account and workspace note caches encrypted
          using macOS secure storage. Clearing a synced local cache removes
          those copies from the current Mac; it does not delete cloud notes, a
          personal account or a shared workspace. Unsynced writing and active
          captures block cache cleanup. Cloud data retention is managed by the
          service and workspace lifecycle settings, separately from local
          cleanup.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="mb-3 text-2xl">Service providers and sharing</h2>
        <p>
          Jotty uses infrastructure providers to store account and meeting data,
          Recall.ai for capture and transcription, OpenRouter and its selected
          model provider for AI processing, and Infobip for transactional
          messages. Optional exports and connections send the selected data to
          the service you connect. Sharing notes in a workspace makes them
          accessible to its authorized members.
        </p>
      </section>
      <section>
        <h2 className="mb-3 text-2xl">Your controls</h2>
        <p>
          You can stop capture, change macOS permissions, disconnect Google and
          clear synced local copies. Use the signed-in web app’s account and
          workspace settings to review the supported management and deletion
          actions. Account deletion and workspace deletion have different
          effects; review the confirmation for the action you choose. For
          questions about meeting data shared with your organization, contact
          your workspace administrator or use Jotty’s account support page.
        </p>
      </section>
    </article>
  );
}
